/**
 * 判断值是否为 null 或 undefined
 * @return 是否为 null 或 undefined
 */
export default function isNil(value) {
    return value === null || value === undefined;
}
//# sourceMappingURL=is-nil.js.map